var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { backCastingTimeSeriesChartOptions } from './config/backtesingConfig';
import '../TimeseriesChart/TimeseriesChart.scss';
export const BackTestingChart = (_a) => {
    var { varSeries, pnlSeries, scrollable, height, width, varSeriesLimit, customOptions } = _a, rest = __rest(_a, ["varSeries", "pnlSeries", "scrollable", "height", "width", "varSeriesLimit", "customOptions"]);
    return (React.createElement("div", { className: "timechart-wrapper" },
        React.createElement(HighchartsReact, Object.assign({ highcharts: Highcharts, options: backCastingTimeSeriesChartOptions({
                varSeries,
                pnlSeries,
                varSeriesLimit,
                scrollable,
                height,
                width,
                customOptions,
            }) }, rest, { customOptions: customOptions }))));
};
//# sourceMappingURL=BacktestingChart.js.map